import { useQuery } from '@tanstack/react-query';
import { getProgramScopedContentRows } from '../../services/programScopedContentService';
import type { ProgramScopeType } from '../../types/domain';
import { schoolKeys } from '../keys';
import { lsInitialDataOptions } from './lsInitialData';
import { readValidScopedContentRowsFromLocalCache } from '../../utils/programScopedContentLsBridge';

export type UseProgramScopedContentByScopeQueryParams = {
  workspaceId: string;
  academicYear: number;
  termNumber: 1 | 2;
  gradeId: string;
  scopeType: ProgramScopeType;
  scopeKey: string;
  enabled?: boolean;
  forceRefresh?: boolean;
};

export function useProgramScopedContentByScopeQuery(params: UseProgramScopedContentByScopeQueryParams) {
  const {
    workspaceId,
    academicYear,
    termNumber,
    gradeId,
    scopeType,
    scopeKey,
    enabled = true,
    forceRefresh = false,
  } = params;
  const ls = readValidScopedContentRowsFromLocalCache(
    workspaceId,
    academicYear,
    termNumber,
    gradeId,
    scopeType,
    scopeKey
  );

  return useQuery({
    queryKey: schoolKeys.programScopedContentRows(
      workspaceId,
      academicYear,
      termNumber,
      gradeId,
      scopeType,
      scopeKey
    ),
    enabled: enabled && !!workspaceId.trim() && !!gradeId.trim() && !!scopeKey.trim() && !!termNumber,
    ...lsInitialDataOptions(ls.found && !forceRefresh, ls.rows),
    queryFn: () =>
      getProgramScopedContentRows(workspaceId, academicYear, termNumber, gradeId, scopeType, scopeKey, {
        forceRefresh,
      }),
  });
}
